import { j as n, r as B, p as nt } from "../../country-c6efbd61.js";
import "../../helper-211c1fae.js";
import at, { useEffect as T, useState as m, useRef as D } from "react";
import { e as j, r as l, i as k, f as st, o as it, g as ct, h as ut, j as lt, d as pt, C as ft } from "../../index-f9900ad0.js";
import { M as dt } from "../../main-08e43649.js";
import { s as C } from "../../index-d5e9de7d.js";
import { E as gt } from "../../EmailLogin-dc1a1449.js";
import { P as yt } from "../../PhoneLogin-73fdca77.js";
import { i as mt } from "../../lib-8435dd62.js";
import "../../index-297063c9.js";
import "../../LoginOpt-672ac86a.js";
import "../../broadcast-channel-3e92c30d.js";
import "../../reactNode-9b187a26.js";
import "../../index-acaa3008.js";
import "../../index-1713962f.js";
import "../../index-d9d6cd26.js";
import "../../link-f8c154eb.js";
function X(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var bt = "[object AsyncFunction]", jt = "[object Function]", vt = "[object GeneratorFunction]", Tt = "[object Proxy]";
function Z(t) {
  if (!X(t))
    return !1;
  var e = j(t);
  return e == jt || e == vt || e == bt || e == Tt;
}
var ht = l["__core-js_shared__"];
const w = ht;
var F = function() {
  var t = /[^.]+$/.exec(w && w.keys && w.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function xt(t) {
  return !!F && F in t;
}
var $t = Function.prototype, Ct = $t.toString;
function p(t) {
  if (t != null) {
    try {
      return Ct.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var wt = /[\\^$.*+?()[\]{}|]/g, _t = /^\[object .+?Constructor\]$/, At = Function.prototype, Mt = Object.prototype, Ot = At.toString, Lt = Mt.hasOwnProperty, Pt = RegExp(
  "^" + Ot.call(Lt).replace(wt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function kt(t) {
  if (!X(t) || xt(t))
    return !1;
  var e = Z(t) ? Pt : _t;
  return e.test(p(t));
}
function Et(t, e) {
  return t == null ? void 0 : t[e];
}
function v(t, e) {
  var r = Et(t, e);
  return kt(r) ? r : void 0;
}
var It = v(l, "WeakMap");
const A = It;
var St = 9007199254740991;
function Q(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= St;
}
function Nt(t) {
  return t != null && Q(t.length) && !Z(t);
}
var Bt = Object.prototype;
function Y(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Bt;
  return t === r;
}
var Dt = "[object Arguments]";
function R(t) {
  return k(t) && j(t) == Dt;
}
var tt = Object.prototype, Ft = tt.hasOwnProperty, Rt = tt.propertyIsEnumerable, Vt = R(function() {
  return arguments;
}()) ? R : function(t) {
  return k(t) && Ft.call(t, "callee") && !Rt.call(t, "callee");
};
const Gt = Vt;
function Ut() {
  return !1;
}
var et = typeof exports == "object" && exports && !exports.nodeType && exports, V = et && typeof module == "object" && module && !module.nodeType && module, Wt = V && V.exports === et, G = Wt ? l.Buffer : void 0, Ht = G ? G.isBuffer : void 0, Kt = Ht || Ut;
const qt = Kt;
var Jt = "[object Arguments]", zt = "[object Array]", Xt = "[object Boolean]", Zt = "[object Date]", Qt = "[object Error]", Yt = "[object Function]", te = "[object Map]", ee = "[object Number]", re = "[object Object]", oe = "[object RegExp]", ne = "[object Set]", ae = "[object String]", se = "[object WeakMap]", ie = "[object ArrayBuffer]", ce = "[object DataView]", ue = "[object Float32Array]", le = "[object Float64Array]", pe = "[object Int8Array]", fe = "[object Int16Array]", de = "[object Int32Array]", ge = "[object Uint8Array]", ye = "[object Uint8ClampedArray]", me = "[object Uint16Array]", be = "[object Uint32Array]", o = {};
o[ue] = o[le] = o[pe] = o[fe] = o[de] = o[ge] = o[ye] = o[me] = o[be] = !0;
o[Jt] = o[zt] = o[ie] = o[Xt] = o[ce] = o[Zt] = o[Qt] = o[Yt] = o[te] = o[ee] = o[re] = o[oe] = o[ne] = o[ae] = o[se] = !1;
function je(t) {
  return k(t) && Q(t.length) && !!o[j(t)];
}
function ve(t) {
  return function(e) {
    return t(e);
  };
}
var rt = typeof exports == "object" && exports && !exports.nodeType && exports, b = rt && typeof module == "object" && module && !module.nodeType && module, Te = b && b.exports === rt, _ = Te && st.process, he = function() {
  try {
    var t = b && b.require && b.require("util").types;
    return t || _ && _.binding && _.binding("util");
  } catch {
  }
}();
const U = he;
var W = U && U.isTypedArray, xe = W ? ve(W) : je;
const $e = xe;
var Ce = it(Object.keys, Object);
const we = Ce;
var _e = Object.prototype, Ae = _e.hasOwnProperty;
function Me(t) {
  if (!Y(t))
    return we(t);
  var e = [];
  for (var r in Object(t))
    Ae.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Oe = v(l, "Map");
const M = Oe;
var Le = v(l, "DataView");
const O = Le;
var Pe = v(l, "Promise");
const L = Pe;
var ke = v(l, "Set");
const P = ke;
var H = "[object Map]", Ee = "[object Object]", K = "[object Promise]", q = "[object Set]", J = "[object WeakMap]", z = "[object DataView]", Ie = p(O), Se = p(M), Ne = p(L), Be = p(P), De = p(A), u = j;
(O && u(new O(new ArrayBuffer(1))) != z || M && u(new M()) != H || L && u(L.resolve()) != K || P && u(new P()) != q || A && u(new A()) != J) && (u = function(t) {
  var e = j(t), r = e == Ee ? t.constructor : void 0, a = r ? p(r) : "";
  if (a)
    switch (a) {
      case Ie:
        return z;
      case Se:
        return H;
      case Ne:
        return K;
      case Be:
        return q;
      case De:
        return J;
    }
  return e;
});
const Fe = u;
var Re = "[object Map]", Ve = "[object Set]", Ge = Object.prototype, Ue = Ge.hasOwnProperty;
function We(t) {
  if (t == null)
    return !0;
  if (Nt(t) && (ct(t) || typeof t == "string" || typeof t.splice == "function" || qt(t) || $e(t) || Gt(t)))
    return !t.length;
  var e = Fe(t);
  if (e == Re || e == Ve)
    return !t.size;
  if (Y(t))
    return !Me(t).length;
  for (var r in t)
    if (Ue.call(t, r))
      return !1;
  return !0;
}
const He = "_dialog_1t0w5_1", Ke = "_bg_1t0w5_9", qe = "_container_1t0w5_15", Je = "_header_1t0w5_23", ze = "_body_1t0w5_34", Xe = "_close_1t0w5_37", Ze = "_dialogContainer_1t0w5_1", y = {
  dialog: He,
  bg: Ke,
  container: qe,
  header: Je,
  body: ze,
  close: Xe,
  dialogContainer: Ze
}, Qe = () => /* @__PURE__ */ n.jsx("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ n.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5839 27.2274C14.2205 27.5909 13.6312 27.5909 13.2678 27.2274L12.7726 26.7321C12.4091 26.3687 12.4091 25.7795 12.7726 25.416L18.1886 20L12.7727 14.584C12.4092 14.2205 12.4092 13.6313 12.7726 13.2679L13.2679 12.7726C13.6313 12.4091 14.2206 12.4091 14.584 12.7726L20 18.1886L25.416 12.7726C25.7795 12.4091 26.3687 12.4091 26.7322 12.7726L27.2274 13.2679C27.5908 13.6313 27.5908 14.2205 27.2274 14.584L21.8114 20L27.2275 25.416C27.5909 25.7795 27.5909 26.3687 27.2275 26.7321L26.7323 27.2274C26.3688 27.5909 25.7796 27.5909 25.4161 27.2274L20 21.8113L14.5839 27.2274Z", fill: "#C3C7CB" }) }), Ye = ({ children: t, onClose: e, open: r }) => /* @__PURE__ */ n.jsx(n.Fragment, { children: r && /* @__PURE__ */ n.jsxs("div", { className: y.dialog, children: [
  /* @__PURE__ */ n.jsx("div", { className: y.bg }),
  /* @__PURE__ */ n.jsx("div", { className: y.container, children: /* @__PURE__ */ n.jsxs("div", { className: y.body, children: [
    /* @__PURE__ */ n.jsx("div", { className: y.close, onClick: e, children: /* @__PURE__ */ n.jsx(Qe, {}) }),
    t
  ] }) })
] }) });
function tr({ open: t = !0, handleClose: e, bannerType: r }) {
  const a = ut(), { config: c } = lt(), { getStarted: i } = a;
  T(() => (t && (document.body.style.overflow = "hidden"), () => {
    document.body.style.overflow = "";
  }), [t]);
  const [f, d] = m(1), [s, h] = m({}), [ot, E] = m(null), [x, g] = m("home");
  T(() => {
    E(
      f === 4 || f === 5 ? s != null && s.user_id ? `${i.welcomeBack} ${(s == null ? void 0 : s.first_name) || ""} 🎉` : `${i.signUpAnAccount} 🎉` : i == null ? void 0 : i.title
    );
  }, [f, s]);
  const I = () => {
    d(1), h({}), g("home");
  }, S = () => {
    d(1), g("email");
  }, N = () => {
    d(1), g("phone");
  };
  return /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(
    Ye,
    {
      onClose: () => {
        document.body.style.overflow = "auto", e == null || e();
      },
      open: t,
      title: ot,
      avatar: s == null ? void 0 : s.avatar,
      children: /* @__PURE__ */ n.jsx(
        "div",
        {
          className: C.main,
          style: { margin: 0, minHeight: "200px", padding: 0, overflow: "unset", borderRadius: "12px 12px 0 0" },
          children: /* @__PURE__ */ n.jsxs(
            "div",
            {
              style: mt ? { display: "flex", justifyContent: "center", alignItems: "center" } : {},
              className: `${C.container} ${C.dialogContainer}`,
              children: [
                x == "home" && /* @__PURE__ */ n.jsx(
                  dt,
                  {
                    dictionary: a,
                    isModal: !0,
                    bannerType: r,
                    handleEmailClick: () => g("email"),
                    handlePhoneClick: () => g("phone")
                  }
                ),
                x == "email" && /* @__PURE__ */ n.jsx(
                  gt,
                  {
                    lang: a,
                    isModal: !0,
                    bannerType: r,
                    handleEmailClick: N,
                    handleBackClick: S,
                    stepModal: f,
                    setLoginType: I,
                    loginData: s,
                    setLoginData: ($) => {
                      d(2), h($);
                    }
                  }
                ),
                x == "phone" && /* @__PURE__ */ n.jsx(
                  yt,
                  {
                    config: c,
                    lang: a,
                    isModal: !0,
                    bannerType: r,
                    stepModal: f,
                    handleEmailClick: S,
                    handleBackClick: N,
                    loginData: s,
                    setLoginType: I,
                    setLoginData: ($) => {
                      d(2), h($);
                    }
                  }
                )
              ]
            }
          )
        }
      )
    }
  ) });
}
const er = ({ bannerType: t }) => {
  const [e, r] = m(!1), a = D(null), c = D(null);
  return T(() => {
    var i;
    a.current && ((i = a.current) == null || i.call(a), a.current = null), a.current = B("SHOW_LOGIN_MODAL", () => {
      r == null || r(!0);
    });
  }, [r]), T(() => {
    var i;
    c.current && ((i = c.current) == null || i.call(c), c.current = null), c.current = B("HIDE_LOGIN_MODAL", () => {
      r == null || r(!1);
    });
  }, [r]), /* @__PURE__ */ n.jsx(tr, { open: e, bannerType: t, handleClose: () => {
    nt("HIDE_LOGIN_MODAL"), r == null || r(!1);
  } });
}, vr = (t) => {
  const { bannerType: e } = t;
  at.useEffect(() => {
  }, []);
  const r = pt("CONFIG");
  return We(r) ? null : /* @__PURE__ */ n.jsx(ft, { ...t, children: /* @__PURE__ */ n.jsx(er, { bannerType: e }) });
};
export {
  vr as default
};
//# sourceMappingURL=index.js.map
